import { computed, unref } from 'vue';
import { useDataStore } from '../../../composables/useVuexStore';
import { TYPE, SELECTED_TYPE_ID } from '../../../store_modules/traitsStore/types';

function connectToStore() {
  const selectedData = useDataStore(SELECTED_TYPE_ID);
  const data = useDataStore(TYPE);

  return {
    data, selectedData,
  };
}

/**
 *
 * @param {{id: string, data: ParsedTypes }} obj
 */
export function useCreateTypeStore({ id, data }) {
  const { data: storeData, selectedData } = connectToStore();

  if (!storeData.has(id)) {
    if (!selectedData.has(id)) {
      selectedData.set(id, data.selectedTypeId);
    }

    storeData.set(id, data);
  }
}

/**
 * @param {import('@vueuse/core').MaybeRef<string>} id
 */
export function useType(id) {
  const { data: storeData, selectedData } = connectToStore();
  const typeData = computed(() => storeData.get(unref(id)));

  const selectedTypeId = computed({
    get() {
      return selectedData.get(unref(id));
    },
    set(val) {
      selectedData.set(unref(id), val);
    },
  });

  /** @type import('vue').ComputedRef<Type | undefined> */
  const selectedType = computed(() => typeData.value?.typeMap[selectedTypeId.value]);
  /** @type import('vue').ComputedRef<Type[]> */
  const types = computed(() => typeData.value?.typeArray || []);
  const label = computed(() => typeData.value?.label || '');

  return {
    label,
    selectedTypeId,
    selectedType,
    types,
  };
}
